import AriaAct from "@resources/aria-act/AriaAct";
import { embedCover } from "@blocks/atonal-video-embed/view";
import FetchModalBasedOnAnchor from "@resources/fetch-modal-based-on-anchor/FetchModalBasedOnAnchor";

class PopupHandler {
	constructor(
		popupSel = '.popup',
		storagePrefix = 'popup'
	){
		this.popups = {};
		this.popupSel = popupSel;
		this.storagePrefix = storagePrefix;
	}

	init(){
		this.index();
		this.process();
	}

	index(sel = this.popupSel){

		let popups = Array.from( document.querySelectorAll(sel) )

		this.popups = popups.map( (popup) => {
			let id = popup.getAttribute('id');
			if( !id ){
				console.error('Popup without id\n' + popup );
				return false;
			}
			return {
				id: id,
				el: popup,
				closeBts: Array.from(document.querySelectorAll(`[aria-controls*="${popup.id}"]`)),
				delay: parseInt( popup.dataset.popupDelay ) || 0,
				storageKey: `${this.storagePrefix}-${id}`,
				showInterval: parseInt( popup.dataset.popupInterval ) || 0,
			}
		})
	}

	process(){
		if( !this.popups.length ) return;

		this.popups.forEach( popup => {
			this.registerToggle(popup)
			this.checkDisplay(popup);
		});
	}

	checkDisplay(popup) {
		setTimeout(() => {
			popup.closeBts.length && this.setTimer(popup) && popup.closeBts[0].click()
		}, popup.delay);
	}

	registerToggle(popup){
		AriaAct.registerListener('click',`[aria-controls="${popup.id}"]`,'expandToggle')
	}

	setTimer(popup) {
		const currentTime = localStorage.getItem(popup.storageKey);
		const timeNow = Date.now();

		if( ! currentTime || currentTime < timeNow ){
			localStorage.setItem(popup.storageKey, timeNow + popup.showInterval);
			return true;
		}

		return false;
	}

}

window.addEventListener('load', () => {
	FetchModalBasedOnAnchor.registerFetch(
		'fetch',
		'single-popup',
		'single-popup',
		'single-fetch-modal popup',
		'.popup',
		'.single-fetch-modal .popup__close-bt',
		(e) => {
			e.htmlContent.classList.forEach(cls => e.modal.classList.add(cls));
			e.modal.setAttribute('style', e.htmlContent.getAttribute('style') );
			embedCover.reindex();
		},
		false
	)
})


const handle = new PopupHandler('.popup', 'moth');
handle.init();
